export const sleep = (ms: number) =>
  // eslint-disable-next-line no-restricted-globals -- Promise 기반 유틸, 훅 사용 불가
  new Promise(resolve => setTimeout(resolve, ms));
